import { BaseResponse } from '../manager/handle_data/HandleData';
import { RoleEnum, roleValues, User } from '../types';
import { toArray } from '../utils/check';
import apiService from './api.service';

interface LoginCredentials {
  username: string;
  password: string;
}

interface LoginResponse {
  accessToken: string;
  expiredAt: string;
  expiresIn: number;
  sessionId: string;
}

class AuthService {
  generateToken(credentials: LoginCredentials): Promise<BaseResponse<LoginResponse>> {
    return apiService.post('/p/b/login', credentials).then((response) => {
      const {
        data: { accessToken },
      } = response.data;

      // Store token in localStorage
      localStorage.setItem('token', accessToken);

      return response.data;
    });
  }

  getUserInfo(): Promise<BaseResponse<User>> {
    return apiService.get('/b/userinfo').then((response) => {
      return response.data;
    });
  }

  revokeToken(): Promise<BaseResponse<{}>> {
    return apiService.delete('/b/logout').then((response) => {
      return response.data;
    });
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  }

  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
    return null;
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  }

  isAllowedPermission(allowedRole: RoleEnum = RoleEnum.Dashboard): boolean {
    const currentUser = this.getCurrentUser();
    const roles = toArray(currentUser?.role);

    const highestRoleValue = Math.max(...roles.map((r) => r.code).map((r) => roleValues[r] || roleValues[RoleEnum.Dashboard]));
    return highestRoleValue >= roleValues[allowedRole];
  }
}

const authService = new AuthService();
export default authService;
